import { z } from "zod";

import { env } from "@/env";
import { investorAnnouncementsCollection } from "@/lib/strapiClient";

const attachmentSchema = z.object({
	id: z.number(),
	name: z.string(),
	file: z.object({
		url: z.string(),
		name: z.string().optional(),
		ext: z.string().optional(),
		mime: z.string().optional(),
	}),
});

const investorAnnouncementLocalizationSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	date: z.string(),
	locale: z.string(),
	attachments: z.array(attachmentSchema).default([]),
});

export const investorAnnouncementSchema = z.object({
	id: z.number(),
	documentId: z.string(),
	title: z.string(),
	date: z.string(),
	locale: z.string(),
	attachments: z.array(attachmentSchema).default([]),
	localizations: z.array(investorAnnouncementLocalizationSchema).default([]),
});

export type InvestorAnnouncement = z.infer<typeof investorAnnouncementSchema>;

export async function getInvestorAnnouncements(
	locale = "mk-MK",
): Promise<InvestorAnnouncement[]> {
	try {
		const response = await investorAnnouncementsCollection.find({
			locale,
			populate: ["attachments", "attachments.file", "localizations"],
			sort: "publishedAt:desc",
		});
		return z.array(investorAnnouncementSchema).parse(response.data);
	} catch (error) {
		console.error("Error fetching investor announcements:", error);
		return [];
	}
}

export function getAttachmentUrl(url: string): string {
	if (url.startsWith("http")) return url;
	return `${env.VITE_STRAPI_BASE_URL}${url}`;
}

export function getAttachmentType(url: string, ext?: string): string {
	const extension = (ext || url.split(".").pop() || "")
		.toLowerCase()
		.replace(".", "");
	if (extension === "xlsx" || extension === "xls") return "XLSX";
	if (extension === "pdf") return "PDF";
	if (extension === "docx" || extension === "doc") return "DOCX";
	return extension.toUpperCase() || "PDF";
}
